import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import {
  getTeamsConstants, NAMESPACE,
  orgActivityConstants,
  teamActivityConstants,
} from './constants';

export const getOrgActivity = createApiAction(
  orgActivityConstants,
  api.getOrgActivity,
);

export const getTeamActivity = createApiAction(
  teamActivityConstants,
  api.getTeamActivity,
);

export const getTeamsList = createApiAction(
  getTeamsConstants,
  api.getTeams,
);

export const setGranularity = createAction(
  `${NAMESPACE}/set_granularity`,
);
